export default __webpack_public_path__ + "static/gallery-2-79be9d0970a04f150756bbbf1cbcc80e.jpeg";